import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../api/auth";

/**
 * Route guard (T01). Redirects to /login when there is no access token.
 * The login flow stores the token + tenant; `apiClient` then attaches the
 * bearer + X-Addy-Tenant-Id headers and the backend authorises per request.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
